import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { ServicePagesState } from './state';

@NgModule({
    imports: [NgxsModule.forFeature([ServicePagesState])],
})
export class ServicePagesStateModule {}
